<template>
  <div class="mb-3">
    <p class="mb-2 text-black-50 small">
      <i :class="['me-1', icon]"></i>
      {{ label }}
    </p>
    <div class="form-floating">
      <input :type="type"
             class="form-control "
             id="floatingInput" :placeholder="title">
      <label for="floatingInput" class="text-black-50">{{ title }}</label>
    </div>
  </div>
</template>

<script>
export default {
  name: "FloatingInput",
  props: {
    title: {
      type: String,
      default: "Title",
    },
    type: {
      type: String,
      default: "text",
    },
    label:{
      type:String,
      default: "Label"
    },
    icon:{
      type:String,
      default: "fa-solid fa-user",
    }
  },
}
</script>

<style scoped>

</style>